import { render, staticRenderFns } from "./AncientIndividualSampleList.vue?vue&type=template&id=15436a10&scoped=true"
import script from "./AncientIndividualSampleList.vue?vue&type=script&lang=js"
export * from "./AncientIndividualSampleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15436a10",
  null
  
)

export default component.exports